import baseApi from "../../common/api/baseApi";

export const sendFindPasswordCodeApi = ({ mbrId }) => {
  return baseApi
    .post("/findPassword/sendCode", { mbrId })
    .then(response => response.data)
    .catch(error => {
      throw error;
    });
};

export const resetPasswordByCodeApi = ({ mbrId, code, password }) => {
  return baseApi
    .post("/findPassword/reset", { mbrId, code, password })
    .then(response => response.data)
    .catch(error => {
      throw error;
    });
};
